import React from "react";
import { ScrollItemChild } from "./types";

export const WrappedObservedItem = (
  child: ScrollItemChild,
  Observer: React.FC
) => {
  return <Observer>{child}</Observer>;
};
